import appReducer from '@/store/slices/app.slice';

// TYPES
import { AppStateType } from '@/types/app.types';

export type StateType = {
  app: AppStateType;
};

const rootReducers = {
  app: appReducer,
};

export default rootReducers;
